import address from "address";
import { resolve } from "any-promise";
import init_idb from './init_idb'

const DB_NAME = 'ckb';
const DB_VERSION = 117; // Use a long long for this value (don't use a float)
const DB_STORE_NAME = 'solutions';

function openIndexedDB () {
  // This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

  var openDB = indexedDB.open(DB_NAME, DB_VERSION);

  openDB.onsuccess = function(event) {
    // store the result of opening the database in the db variable.
    db = openDB.result
    console.log("Database opened.")
    console.log(`Database version: ${db.version}`)
  
    // add listener to handle the database version change
    db.onversionchange = function() {
      console.log("Database is outdated, please reload the page.")
  
      //!important when version change is detected close the database immediately
      db.close()
      // instruct the user to reload the page via popup
      // and block any interaction with the site
      // launchPopup($newVersionPopupContent)
      alert("Database is outdated, please reload the page.")
      window.location.reload()
    }
  }
  
  openDB.onupgradeneeded = function(event) {
    init_idb(event)
  };

  openDB.onerror = function(error){
    console.log("Erro open db: ", error)
  }

  return openDB;
}

function getStoreIndexedDB (openDB, mode) {
  var db = {};
  db.result = openDB.result;
  db.tx = db.result.transaction(DB_STORE_NAME, mode);
  db.thisStore = db.tx.objectStore(DB_STORE_NAME);
  
  
  return db;
}

export default{
  store_solutions(allSolutions){  
    // console.log({allSolutions});
    return new Promise(resolve =>{
      this.clear_solutions().then(() => {

        //    // auto-comment// console.log("entrou no store");
        var openDB = openIndexedDB();

        openDB.onsuccess = function() {
          var db = getStoreIndexedDB(openDB, 'readwrite');
  
          var addRequest = db.thisStore.add({allSolutions});
          addRequest.onsuccess = function(){
            //    // auto-comment// console.log("Solutions armazenadas para uso offline")
            resolve(true)
          }
          addRequest.onerror = function(error){
               // auto-comment// console.log("idb Erro ao tentar armazenar as solutions", error)
            resolve(false)
          }
          
        }
      });
      
      
    })

    
  },

  clear_solutions() {
    return new Promise(resolve => {
      //    // auto-comment// console.log('start clear');
      
      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');
  
        var clearRequest = db.thisStore.clear();
  
        clearRequest.onsuccess = function() {
             // auto-comment// console.log("Solutions foram apagadas do store");
          resolve(true)
        }
        clearRequest.onerror = function(error){
             // auto-comment// console.log("nao foi possível limpar o store de solutions", error)
          resolve(false)
        }
      }
      
    })
    
  },

  get_solutions(){
    return new Promise(resolve => {
      var solutions = [];

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readonly');
  
        db.thisStore.openCursor().onsuccess = function(event) {
          var cursor = event.target.result;
          if (cursor) {
            solutions.push(cursor.value.allSolutions);
            cursor.continue();
          }else{
               // auto-comment// console.log("estas sao as solutions salvas: ", solutions[0])
            resolve(solutions[0])
          }
        };
        
      }      
      
    })
    
  }
}
